<template>
  <header class="topbar">
    <button class="topbar__menu-btn" @click.stop="$emit('toggle-sidebar')">
      <b-icon icon="list"></b-icon>
    </button>

    <!-- Breadcrumb / Page title -->
    <div class="topbar__title">{{ pageTitle }}</div>

    <div class="topbar__right">
      <span class="topbar__date">{{ fechaHoy }}</span>
      <div class="topbar__user-chip">
        <div class="topbar__avatar">{{ userInitials }}</div>
        <span class="topbar__user-name">{{ userName }}</span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppTopbar',
  emits: ['toggle-sidebar'],
  computed: {
    userName() { return sessionStorage.getItem('Nombre') || 'Admin' },
    userInitials() {
      const n = this.userName
      const parts = n.trim().split(' ')
      return parts.length >= 2
        ? (parts[0][0] + parts[1][0]).toUpperCase()
        : n.slice(0, 2).toUpperCase()
    },
    pageTitle() {
      const map = {
        '/Marcas': 'Marcas', '/Submarcas': 'Submarcas', '/Modelos': 'Modelos',
        '/Promociones': 'Promociones', '/Novedades': 'Novedades',
        '/Usuarios': 'Usuarios', '/Sugerencias': 'Sugerencias',
        '/Aboutus': 'Nosotros'
      }
      return map[this.$route.path] || 'Dashboard'
    },
    fechaHoy() {
      return new Date().toLocaleDateString('es-MX', { weekday: 'long', day: 'numeric', month: 'long' })
    }
  }
}
</script>

<style scoped>
.topbar {
  height: var(--topbar-height);
  background: var(--card-bg);
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  padding: 0 24px;
  gap: 16px;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 1px 6px rgba(0,0,0,0.06);
}

.topbar__menu-btn {
  background: none; border: none;
  font-size: 1.4rem;
  color: var(--primary);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: background 0.2s;
  display: none;
}
.topbar__menu-btn:hover { background: var(--bg); }

@media (max-width: 991px) { .topbar__menu-btn { display: flex; align-items: center; } }

.topbar__title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--primary);
  flex: 1;
  text-transform: capitalize;
}

.topbar__right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.topbar__date {
  font-size: 0.78rem;
  color: var(--text-muted);
  text-transform: capitalize;
}

@media (max-width: 575px) { .topbar__date { display: none; } }

.topbar__user-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: 24px;
  padding: 4px 12px 4px 4px;
}

.topbar__avatar {
  width: 28px; height: 28px;
  border-radius: 50%;
  background: var(--primary);
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
  display: flex; align-items: center; justify-content: center;
}

.topbar__user-name {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text);
}

@media (max-width: 575px) { .topbar__user-name { display: none; } }
</style>
